import type { Membership } from '@space-shell/common/services/membership/types'
import { create } from 'zustand'
import { persist, devtools } from 'zustand/middleware'

import { MEMBERSHIP_STORE_KEY } from './constants'
import type { MembershipStoreType } from './types'

export const useMembershipStore = create<MembershipStoreType>()(
  devtools(
    persist(
      (set) => ({
        membershipSlug: '',
        membershipData: {} as Membership,
        setMembershipSlug: (membershipSlug: string): void => set({ membershipSlug }),
        setMembershipData: (membershipData: Membership): void => set({ membershipData })
      }),
      {
        name: MEMBERSHIP_STORE_KEY
      }
    )
  )
)
